export default "__VITE_ASSET__1d330a18__"